import React, { FC, useCallback, useContext, useEffect, useState } from 'react';

import { TableCell, TableRow } from '@material-ui/core';

import { GlobalContext } from '../../../../../../../../store';
import { IResult } from '../../../../../../../../store/admin/roundResults/store';

import RoundScoreSummary from '../../../../../../../../components/RoundScoreSummary/RoundScoreSummary';
import { useBoolean } from '../../../../../../../common/Hooks/useBoolean.hook';
import { useSummaryStateLogic } from '../../../../../../Common/Hooks/useSummaryStateLogic';
import { useAssignResultsState } from '../../../../../Common/AssignResults/Context/AssignResults.context';
import { getResultField } from '../../../../../Common/ResultsTable/Utils/getResultField';
import { getResultPosition } from '../../../../../Common/ResultsTable/Utils/getResultPosition';
import ResultsFooter from '../../../../../RoundResults/ResultsFooter';
import { useGetAdminEvent } from '../../../../../../../../contrib/Hooks/useGetAdminEvent';
import { useAdminRound } from '../../../../../../../../contrib/Hooks/useAdminRound.hook';
import { useRouteInfoState } from '../../../../../../../../components/RouteInfo/Context/RouteInfo.context';

interface IStrokeTableRow {
  result: IResult;
  showNoPosition?: boolean;
}

export const StrokeTableRow: FC<IStrokeTableRow> = props => {
  const { result, showNoPosition } = props;
  const { selectedCombination } = useAssignResultsState();

  const { clubId, eventId, roundId: propsRoundId } = useRouteInfoState();

  const {
    actions: {
      roundScores: { save: saveRoundScores },
      adminEventRounds: { updateGames, get: getAdminEventRound },
      roundScores: { get: getRoundScores }
    },
    adminEventRounds: rounds,
    roundScores
  } = useContext(GlobalContext);

  const [roundId, setRoundId] = useState(Number(propsRoundId));

  const [signed, setSigned] = useState(false);
  const event = useGetAdminEvent(eventId);
  const [expandedRow, , toggleExpandedRow] = useBoolean(false);

  const [formatIsStableford, setFormatIsStableford] = useState(false);

  useEffect(() => {
    if (selectedCombination) {
      setFormatIsStableford(selectedCombination.format.scoringFormat === 1);
    }
  }, [selectedCombination]);

  const updateRound = useCallback(async (newRoundId: string) => {
    await getAdminEventRound(Number(clubId), Number(eventId), Number(newRoundId));
    await getRoundScores(clubId, eventId, newRoundId);

    setRoundId(Number(newRoundId));
  }, []);

  const {
    onCancelEdit,
    onChangeRound,
    onSave,
    onToggleEdit,
    selectedScores,
    editMode,
    penalties,
    setPenalties,
    player,
    setNewScores
  } = useSummaryStateLogic({
    clubId: Number(clubId),
    eventId: Number(eventId),
    playerId: result.enrollmentId,
    roundId: Number(roundId),
    roundScores,
    rounds,
    saveRoundScores,
    updateGames,
    updateRound
  });

  const [round] = useAdminRound(roundId);

  const [playerIndex, setPlayerIndex] = useState<number | undefined>();

  useEffect(() => {
    if (round && player) {
      const games = round.groups.flatMap(group => group.games);

      const gameFound = games.find(roundRame => roundRame.enrollment === player.id);

      if (gameFound) {
        setPlayerIndex(gameFound.index);
      }
    }
  }, [round, player]);

  return selectedCombination ? (
    <>
      <TableRow onClick={toggleExpandedRow} className="results-table-table-body-row">
        <TableCell>
          {getResultPosition(
            result,
            selectedCombination.format.format.prefix,
            selectedCombination.scoreType,
            selectedCombination.format.considerFlights,
            showNoPosition,
            formatIsStableford
          )}
        </TableCell>

        <TableCell>{`${result.userFirstName} ${result.userLastName}`}</TableCell>

        <TableCell colSpan={selectedCombination.format.format.prefix !== 'stroke' ? 2 : 1}>
          {getResultField(
            result,
            formatIsStableford ? 'Score' : 'AuxScore',
            selectedCombination.format.format.prefix,
            selectedCombination.scoreType,
            false,
            formatIsStableford
          )}
        </TableCell>

        <TableCell>{result.through}</TableCell>
      </TableRow>

      {expandedRow && player && (
        <TableRow className="expandable-row" key={`hiddenTableRow-`}>
          <TableCell
            className="inner-cell"
            colSpan={4}
            classes={{ root: 'leaderboard-row-event-summary' }}
          >
            <RoundScoreSummary
              editing={editMode}
              footer={ResultsFooter(
                onToggleEdit,
                onCancelEdit,
                onSave,
                editMode,
                event ? event.rounds : [],
                onChangeRound,
                roundId
              )}
              hideHeader={true}
              item={player as any}
              onChange={setNewScores}
              onChangePenalties={setPenalties}
              onChangeSignature={setSigned}
              penalties={penalties}
              playerIndex={playerIndex}
              playerScores={selectedScores}
              signed={signed}
            />
          </TableCell>
        </TableRow>
      )}
    </>
  ) : (
    <></>
  );
};
